///
/// EarthBrowser
///
/// Created by Matt Giger on 12/20/2024
/// Copyright (c) 2024 Geodata Labs
///

import { Skeleton } from "@/components/ui/skeleton"
import { cn } from "@/utils/utils"

export function SkeletonCard({ className }: { className?: string }) {
	return (
		<div className={cn("flex flex-col space-y-3", className)}>
			<Skeleton className="h-[125px] w-full rounded-xl" />
			<div className="space-y-2">
				<Skeleton className="h-4 w-1/2" />
				<Skeleton className="h-4 w-1/2" />
			</div>
		</div>
	)
}
